module.exports = __webpack_public_path__ + "static/media/icon_146.7f76331c.svg";